import type { ReactNode } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Props {
  titleKey: string;
  children?: ReactNode;
}

export default function AccountSubLayout({ titleKey, children }: Props) {
  const { t } = useTranslation();
  const { restaurantUuid } = useParams<{ restaurantUuid: string }>();
  return (
    <div className="max-w-[800px] mx-auto px-4 py-8">
      <div className="mb-2 text-sm text-ink/70 flex items-center gap-2">
        {/* SC-1091 m5: 44 px tall — it was 20 px, a fingertip missed it. */}
        <Link to={`/${restaurantUuid}/account`} className="underline inline-flex min-h-[44px] items-center">{t('account_sub.back')}</Link>
      </div>
      <h1 className="font-display text-3xl mb-6 text-ink">{t(titleKey)}</h1>
      {children}
    </div>
  );
}
